import { Component } from '@angular/core';

@Component({
  selector: 'app-no-company-found',
  templateUrl: './no-company-found.component.html',
  styleUrls: ['./no-company-found.component.scss']
})
export class NoCompanyFoundComponent {

}
